/* eslint-disable */
import axios from "axios";
import moment from "moment";
import format from "date-fns/format";
import payloadDictionary from "@/components/pages/performance/payload_dictionary.json";
// import { GraphHTTP } from "../utils/http-common";
import HttpUtils from "../utils/http-common";
const WAIT = 60000 * 5;
const login = ({ commit }) => commit("setLogin", true);
const logout = ({ commit }) => commit("setLogin", false);
const timeAgo = (date, timeRN) => {
  // console.log({ date, timeRN, ago: moment(date).from(timeRN) });
  // let ta=undefined==
  return moment(date).from(timeRN);
};

const statusCalc = date => {
  // console.log( moment(date).diff(this.timeRightNow));
  var difference = Math.abs(moment(date).diff(this.timeRightNow));
  if (difference / 60000 > 90) {
    return true;
  } else {
    return false;
  }
};

const transformMapData = MapData => {
  return Object.keys(MapData).reduce((cummData, key) => {
    let oldKey = payloadDictionary.find(x => x.new_key == key);
    if (oldKey && oldKey["old_key"] != "") {
      cummData[oldKey["old_key"]] = MapData[key];
    } else {
      cummData[key] = MapData[key];
    }
    return cummData;
  }, {});
};
const transformListData = ListData => {
  if (ListData !== null) {
    return ListData.map(x => {
      return x.length ? transformListData(x) : transformMapData(x);
    });
  }
  return [];
};

const flagsDict = {
  errors: {
    InverterFault: "Inverter Fault",
    BusOver: "Bus Overload",
    BusUnder: "Bus Underload",
    BusSoftFail: "Bus Failed",
    InverterVoltageTooLow: "Inverter Voltage Too Low",
    InverterVoltageTooHigh: "Inverter Voltage Too High",
    InverterOverCurrent: "Inverter Overcurrent",
    InverterSoftFail: "Inverter failed (soft)",
    SelfTestFail: "Self test failed",
    OPDCVoltageOpen: "",
    BatteryOpen: "Battery Open",
    BatteryLowAlarm: "Battery Low",
    CurrentSensorFail: "Current Sensor failed"
  },

  warnings: {
    lineFail: "Line Failed",
    LineFail: "Line Failed",
    OPVShort: "Pv Output Short Circuit",
    BatteryUnderShutdown: "Battery Under Shortdown",
    EepromFault: "EEPROM Fault",

    PVLoss: "No supply from PV",
    BatteryDerating: "Battery Derating",
    Overload: "System Overload"
  }
};
const errorCalc = Payload => {
  var excluded = [
    "id",
    "deviceID",
    "InverterId",
    "Timestamp",
    "updatedAt",
    "lineFail"
  ];
  var alarmFlags = {};
  for (var property in Payload) {
    if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
      if (Payload[property] > 0) {
        if (flagsDict.warnings[property]) {
          alarmFlags["warning"]
            ? alarmFlags["warning"]++
            : (alarmFlags["warning"] = 1);
        } else if (flagsDict.errors[property]) {
          alarmFlags["error"]
            ? alarmFlags["error"]++
            : (alarmFlags["error"] = 1);
        }
      }
    }
  }

  return {
    count: Object.keys(alarmFlags).reduce((all, x) => {
      return (all += alarmFlags[x]);
    }, 0),
    flags: alarmFlags
  };
};

const loginNetwork = ({ commit }) => {
  commit("setLoading", true);
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      commit("setLogin", true);
      commit("setLoading", false);
      resolve();
    }, 3000);
  });
};

const setUserSession = ({ commit }, user) => {
  commit("setUser", user);
};

const setAccess = ({ commit }, access) => {
  commit("setAccess", access);
};
const setGlobalTableOptions = ({ commit }, globalTableOptions) => {
  commit("setGlobalTableOptions", globalTableOptions);
};
const setPerformanceFilter = ({ commit }, performanceFilter) => {
  console.log({ performanceFilter });
  commit("setPerformanceFilter", performanceFilter);
};
const setHome = ({ commit }, status) => {
  commit("setHome", status);
};
const setDrawerMode = ({ commit }, status) => {
  commit("setDrawerMode", status);
};
const setRole = ({ commit }, roles) => {
  commit("setRole", roles);
};

const toggleSidebar = ({ commit }, status) => {
  commit("toggleSidebar", status);
};

const setTheme = ({ commit }, theme = null) => {
  commit("setTheme", theme);
};

const fillDeviceList = ({ commit }, list) => {
  HTTP.get("/online-devices", {
    params: {
      // $limit: 20
    }
  })
    .then(function(response) {
      commit("fillDeviceList", response.data);
    })
    .catch(function(error) {
      console.log(error);
    });
  HTTP.get("/devices", {
    params: {
      // $limit: 20
    }
  })
    .then(function(response) {
      commit("fillOffDeviceList", response.data);
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const HTTP = axios.create({
  // baseURL: 'http://localhost:3030',
  baseURL: "https://iot-solarbase.arnergy.com",
  headers: {
    // Authorization: 'Bearer {token}'
  }
});
const handleFilters = ({ commit, getters }) => {
  filters({ commit, getters });
};
const filters = ({ commit, getters }) => {
  let filterFirmWarVersion = getters.filterFirmWarVersion;
  let filterSectorVal = getters.filterSectorVal;
  let filterPaymentModel = getters.filterPaymentModel;
  // console.log({ filterFirmWarVersion, filterSectorVal, filterPaymentModel });

  if (
    filterSectorVal.length === 0 &&
    filterFirmWarVersion.length === 0 &&
    filterPaymentModel.length === 0
  ) {
    clearFilters({ commit, getters });
    return;
  }
  let all = getters.graphDeviceDetails;
  let online = getters.onLineDevices;
  let alarm = getters.alarmDevices;
  let offline = getters.offLineDeviceList;

  let allDeviceFilter = all.filter(item => {
    return (
      item.sector === filterSectorVal ||
      item.FV === filterFirmWarVersion ||
      item.paymentModel === filterPaymentModel
    );
  });
  let onlineDeviceFilter = online.filter(item => {
    return (
      item.sector === filterSectorVal ||
      item.FV === filterFirmWarVersion ||
      item.paymentModel === filterPaymentModel
    );
  });
  let offLineDeviceFilter = offline.filter(item => {
    return (
      item.sector === filterSectorVal ||
      item.FV === filterFirmWarVersion ||
      item.paymentModel === filterPaymentModel
    );
  });
  let alarmDeviceFilter = alarm.filter(item => {
    return (
      item.sector === filterSectorVal ||
      item.FV === filterFirmWarVersion ||
      item.paymentModel === filterPaymentModel
    );
  });
  setFilteredResponse(
    { commit, getters },
    allDeviceFilter,
    onlineDeviceFilter,
    offLineDeviceFilter,
    alarmDeviceFilter
  );
};

const setFilteredResponse = (
  { commit, getters },
  filteredAllDevices,
  filteredOnlineDevices,
  filteredOffLineDevices,
  filteredAlarmDevices
) => {
  commit("filteredAllDevices", filteredAllDevices);
  commit("filteredOnlineDevices", filteredOnlineDevices);
  commit("filteredOffLineDevices", filteredOffLineDevices);
  commit("filteredAlarmDevices", filteredAlarmDevices);
};

const setCriticalSystems = ({ commit, getters }, list) => {
  commit("setCriticalSystems", list);
};

const clearFilters = ({ commit, getters }) => {
  commit("filteredAllDevices", getters.graphDeviceDetails);
  commit("filteredOnlineDevices", getters.onLineDevices);
  commit("filteredOffLineDevices", getters.offLineDeviceList);
  commit("filteredAlarmDevices", getters.alarmDevices);
};
const clearFVFilter = ({ commit, getters }, payload) => {
  if (payload.length === 0) {
    commit("filteredAllDevices", getters.graphDeviceDetails);
    commit("filteredOnlineDevices", getters.onLineDevices);
    commit("filteredOffLineDevices", getters.offLineDeviceList);
  }
};
const refreshList = ({ commit }, list) => {
  return HTTP.get("/online-devices")
    .then(response => response.data.Items)
    .then(devices => {
      return HTTP.get("/devicemode").then(modes => {
        return {
          devices,
          modes: modes.data.Items
        };
      });
    })
    .then(tempData => {
      return HTTP.get("/device-expiry").then(expiries => {
        return {
          ...tempData,
          expiries: expiries.data.Items
        };
      });
    })
    .then(data => {
      commit("fillDeviceList", data);
      // console.log(data);
      return data;
    })
    .then(transformedData => {
      transformedData["devices"].map(item => {
        // console.log(item);
        var inverterId = item.DeviceID;
        var headers = {
          "Content-Type": "application/plain"
        };
        let data = {
          TableName: "Warnings",
          KeyConditionExpression:
            "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
          ExpressionAttributeValues: {
            ":key": inverterId * 1,
            ":sub": moment().format("YYYY-MM-DD")
          },
          Limit: 1,
          ScanIndexForward: false
        };
        return HTTP.post(`/devicedata`, data, {
          headers
        })
          .then(resp => {
            let DevData = resp.data.Items;
            if (DevData[0]) {
              // aggr[inverterId]=DevData[0]["payload"];
              commit("updateWarning", DevData[0]);
            }
          })
          .catch();
      });
    })
    .catch(function(error) {
      console.log(error);
    });
};
const findDeviceData = (dataset, key, value) => {
  const res = dataset.filter(x => x[key] == value);
  return res.length > 0 ? res : undefined;
};
const batteryMode = (mode, version) => {
  if (version == "v4") {
    var resp = "--";
    var formattedMode =
      mode.split("").length > 1
        ? mode.split("")[1]
        : mode || "inv not detected";
    switch (formattedMode) {
      case "P":
      case "00":
        resp = "Power On";
        break;
      case "S":
      case "SB":
      case "01":
        resp = "On Standby";
        break;
      case "L":
      case "E":
      case "05":
        resp = "On Grid";
        break;
      case "Y":
      case "02":
        resp = "Bypass Mode";
        break;
      case "B":
      case "03":
        resp = "On Battery";
        break;
      case "F":
      case "04":
        resp = "Fault";
        break;
      case "H":
        resp = "Power saving mode";
        break;
      case "C":
      case "06":
        resp = "Charging";
        break;
      default:
        resp = formattedMode;
    }
    // console.log(resp);
    return resp;
  } else if (version == "v3") {
    var resp = "--";
    var formattedMode =
      mode.split("").length > 1
        ? mode.split("")[1]
        : mode || "inv not detected";
    switch (formattedMode) {
      case "P":
        resp = "Power On";
        break;
      case "S":
        resp = "On Standby";
        break;
      case "L":
        resp = "On Grid";
        break;
      case "E":
        resp = "On Grid";
        break;
      case "Y":
        resp = "Bypass Mode";
        break;
      case "B":
        resp = "On Battery";
        break;
      case "F":
        resp = "Fault";
        break;
      case "H":
        resp = "Power saving mode";
        break;
      case "C":
        resp = "Charging";
        break;
      default:
        resp = formattedMode;
    }
    // console.log(resp);
    return resp;
  } else {
    let resp = "--";
    /***
     * v6 mode data
     * @constant
     * SB -- Standby
     * FL --  Failure
     * SC --  Self check
     * NM -- Normal
     * AL --- Alarm
     * * */

    var formattedMode =
      mode.split("").length > 1
        ? mode.split("")[1]
        : mode || "inv not detected";
    switch (formattedMode) {
      case "P":
        resp = "Power On";
        break;
      case "S":
      case "SB":
        resp = "On Standby";
        break;
      case "L":
        resp = "On Grid";
        break;
      case "B":
      case "NM":
        resp = "On Battery";
        break;
      case "F":
      case "FL":
        resp = "Fault";
        break;
      case "H":
        resp = "Power saving mode";
        break;
      case "C":
        resp = "Charging";
        break;
      default:
        resp = formattedMode;
    }
    return resp;
  }
};
const currentTime = async () => {
  let response = await HTTP.get(
    "https://arnergy.com/weather-api/time/?" + Date.now()
  );
  // console.log(response.data.datetime);
  if (response) {
    if (response.data.datetime) {
      let tmpDate = response.data.datetime.split(".")[0];
      return tmpDate;
    } else {
      return null;
    }
  }
};
const performanceGraphCall = async ({ commit, getters }, payload) => {
  const timeRN = payload.timeRN || payload; //for other user type aside customer...
  const arrayOfIds = payload.arrayOfIds;
  // console.log('>>>>>>>>>>>>>>>>>>>', timeRN, payload)
  poll({ commit, getters }, timeRN, arrayOfIds);
};

const poller = async ({ commit, getters }, timeRN, arrayOfIds) => {
  let timeRightNow = await currentTime();
  // console.log({timeRightNow});
  poll({ commit, getters }, timeRightNow || timeRN, arrayOfIds);
};

const performanceGraphCall2 = async ({ commit, getters }, payload) => {
  const timeRN = payload.timeRN || payload; //for other user type aside customer...
  const arrayOfIds = payload.arrayOfIds;
  poll2(
    { commit, getters },
    timeRN,
    arrayOfIds,
    payload.limit,
    payload.page,
    payload
  );
};

const poller2 = async ({ commit, getters }, timeRN, arrayOfIds, payload) => {
  let timeRightNow = await currentTime();
  poll2({ commit, getters }, timeRightNow || timeRN, arrayOfIds, ...payload);
};

const poll = async ({ commit, getters }, timeRN, arrayOfIds) => {
  const hasArrayOfIds = arrayOfIds ? true : false;
  let url = "/graphql";

  return cachedPollCall(url, arrayOfIds, timeRN, { commit, getters });
};

const poll2 = async (
  { commit, getters },
  timeRN,
  arrayOfIds,
  limit = 20,
  page = 1,
  payload
) => {
  let devicePath = "";

  if (payload && payload.search) {
    devicePath = `&search=${payload.search}`;
  }

  if (payload && payload.filter) {
    devicePath += `&filter=${payload.filter}`;
  }

  if (payload && payload.sortField) {
    devicePath += `&sortField=${payload.sortField}&sortOrder=${payload.sortOrder}`;
  }

  const hasArrayOfIds = arrayOfIds ? true : false;
  let url = `/devices?limit=${limit}&page=${page}${devicePath}`;

  if (hasArrayOfIds) {
    url = `/devices?limit=${limit}&page=${page}${devicePath}&deviceIds=${arrayOfIds.join(
      ","
    )}`;
  }
  return cachedPollCall2(url, arrayOfIds, timeRN, { commit, getters });
};

const cachedPollCall = (url, arrayOfIds, timeRN, { commit, getters }) => {
  let query = `
  {
    devices {
      DeviceID
      mode
      payload
      expiry
      owner {
        CID
        name
        user
        locations
        deviceType
        email
        sector
      }
      request {
        paymentmodel
      }
    }
  }

`;

  return HttpUtils.GraphHTTP.post(url, { query })
    .then(res => {
      let devices = res.data.data.devices;
      handleSuccess(devices, timeRN, arrayOfIds, { commit, getters });
    })
    .catch(err => {
      console.log(err);
      sleep(WAIT).then(() => {
        poller({ commit, getters }, timeRN, arrayOfIds);
      });
    });
};

const cachedPollCall2 = (url, arrayOfIds, timeRN, { commit, getters }) => {
  commit("loadingState", true);
  return HttpUtils.FastAPIHTTP.get(url)
    .then(res => {
      commit("loadingState", false);
      let devices = res.data.data.devices;
      console.log("running this", res);
      handleSuccess2(devices, timeRN, arrayOfIds, res.data.data, {
        commit,
        getters
      });
    })
    .catch(err => {
      console.log(err);
      sleep(WAIT).then(() => {
        poller2({ commit, getters }, timeRN, arrayOfIds);
      });
    });
};

const handleSuccess2 = (
  devices,
  timeRN,
  arrayOfIds,
  data,
  { commit, getters }
) => {
  const pagination = {
    currentPage: data.currentPage,
    limit: data.limit,
    totalPages: data.totalPages,
    totalRecords: data.totalRecords,
    deviceAnalytics: data.deviceAnalytics
  };

  commit("fillDeviceList", devices);
  commit("devicePayload", pagination);
  let arr = construct(devices, timeRN);

  let offLines = arr.filter(x => {
    let type = true;
    return x && type ? statusCalc(x.TimeStamp) == true : false;
  });
  let sysAlarms = arr.filter(x => {
    let type = true;
    return x && x.Alarms ? true : false;
  });

  let onLines = arr.filter(x => {
    let type = true;

    return x && type ? statusCalc(x.TimeStamp) == false : true;
  });

  commit("graphDeviceDetails", arr || []);
  commit("offLineDevices", offLines || []);
  commit("alarmDevices", sysAlarms || []);
  commit("onLineDevices", onLines || []);

  let filterFirmWarVersion = getters.filterFirmWarVersion;
  let filterSectorVal = getters.filterSectorVal;
  let filterPaymentModel = getters.filterPaymentModel;
  if (
    filterFirmWarVersion === "" &&
    filterSectorVal === "" &&
    filterPaymentModel === ""
  ) {
    commit("filteredAllDevices", arr || []);
    commit("filteredOnlineDevices", onLines || []);
    commit("filteredAlarmDevices", sysAlarms || []);
    commit("filteredOffLineDevices", offLines || []);
  } else {
    handleFilters({ commit, getters });
  }
  let uniqueFV = uniqueFilter(arr);
  let uniqueSectors = uniqueSectorsFilter(arr);
  let uniquePaymentModel = uniquePaymentModelFilter(arr);

  uniqueSectors.unshift({ sector: "clear", id: 0 });
  uniquePaymentModel.unshift({ paymentModel: "clear", id: 0 });
  uniqueFV.unshift({ FV: "clear", id: 0 });
  commit("uniqueFV", uniqueFV || []);
  commit("uniqueSectors", uniqueSectors || []);
  commit("uniquePaymentModel", uniquePaymentModel || []);

  sleep(WAIT).then(() => {
    poller2({ commit, getters }, timeRN, arrayOfIds);
  });
  // setTimeout(poller({ commit }, timeRN), 60000);
};

const handleSuccess = (devices, timeRN, arrayOfIds, { commit, getters }) => {
  commit("fillDeviceList", devices);
  let arr = construct(devices, timeRN);

  let offLines = arr.filter(x => {
    let type = true;
    return x && type ? statusCalc(x.TimeStamp) == true : false;
  });
  let sysAlarms = arr.filter(x => {
    let type = true;
    return x && x.Alarms ? true : false;
  });

  let onLines = arr.filter(x => {
    let type = true;

    return x && type ? statusCalc(x.TimeStamp) == false : true;
  });

  commit("graphDeviceDetails", arr || []);
  commit("offLineDevices", offLines || []);
  commit("alarmDevices", sysAlarms || []);
  commit("onLineDevices", onLines || []);

  let filterFirmWarVersion = getters.filterFirmWarVersion;
  let filterSectorVal = getters.filterSectorVal;
  let filterPaymentModel = getters.filterPaymentModel;
  if (
    filterFirmWarVersion === "" &&
    filterSectorVal === "" &&
    filterPaymentModel === ""
  ) {
    commit("filteredAllDevices", arr || []);
    commit("filteredOnlineDevices", onLines || []);
    commit("filteredAlarmDevices", sysAlarms || []);
    commit("filteredOffLineDevices", offLines || []);
  } else {
    handleFilters({ commit, getters });
  }
  let uniqueFV = uniqueFilter(arr);
  let uniqueSectors = uniqueSectorsFilter(arr);
  let uniquePaymentModel = uniquePaymentModelFilter(arr);
  // console.log({ uniquePaymentModel });

  uniqueSectors.unshift({ sector: "clear", id: 0 });
  uniquePaymentModel.unshift({ paymentModel: "clear", id: 0 });
  uniqueFV.unshift({ FV: "clear", id: 0 });
  commit("uniqueFV", uniqueFV || []);
  commit("uniqueSectors", uniqueSectors || []);
  commit("uniquePaymentModel", uniquePaymentModel || []);

  sleep(WAIT).then(() => {
    poller({ commit, getters }, timeRN, arrayOfIds);
  });
  // setTimeout(poller({ commit }, timeRN), 60000);
};

const roundUp = num => {
  return Math.round(num * 100) / 100;
};
const uniqueFilter = arr => {
  var resArr = [];
  arr.filter(function(item) {
    var i = resArr.findIndex(x => x.FV == item.FV);
    if (i <= -1) {
      resArr.push(item);
    }
    return null;
  });
  return resArr;
};

const uniqueSectorsFilter = arr => {
  var resArr = [];
  arr.filter(function(item) {
    var i = resArr.findIndex(x => x.sector == item.sector);
    if (i <= -1) {
      resArr.push(item);
    }
    return null;
  });
  return resArr;
};
const uniquePaymentModelFilter = arr => {
  var resArr = [];
  arr.filter(function(item) {
    var i = resArr.findIndex(x => x.paymentModel == item.paymentModel);
    if (i <= -1) {
      resArr.push(item);
    }
    return null;
  });
  return resArr;
};
const sleep = (ms = WAIT) => {
  // console.log(ms + "here");

  return new Promise(resolve => setTimeout(resolve, ms));
};
const panelPowerReduce = (InverterData, version = "v3") => {
  var power = InverterData
    ? InverterData.reduce((acc, parameter) => {
        let powerKey = `PVCgP${version == "v4" ? "1" : ""}`;
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0)
    : "";
  if (version == "v5") {
    console.log({ power });
  }
  return power / 1000 + "kW";
};

const panelPowerReduceRaw = (InverterData, version = "v3") => {
  var power = InverterData
    ? InverterData.reduce((acc, parameter) => {
        let powerKey = `PVCgP${version == "v4" ? "1" : ""}`;
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0)
    : "";
  return power;
};
const panelPower = PVChargingPower => {
  var power = roundUp((PVChargingPower * 1) / 1000);
  return power + "kW";
};

const panelPowerRaw = PVChargingPower => {
  var power = roundUp(PVChargingPower * 1);
  return power;
};

const roundDown = num => {
  return parseInt(num) > 100 ? 100 : num;
};

const installedCapacity = device => {
  let { MiscData, InstPV } = device.payload;
  if (MiscData) {
    return Number(MiscData.InstallSize) + "kVA";
  } else if (device.deviceType) {
    return device.deviceType.indexOf("3000") > -1
      ? 3
      : device.deviceType.indexOf("2000") > -1
      ? 2
      : 5 + "kVA";
  } else return 0 + "kVA";
};
const installedPv = device => {
  let { InstPV } = device.payload;
  return InstPV;
};

const contractualLoad = device => {
  let { InstPV } = device.payload;
  return InstPV;
};

const getExtraSourceWhileOnBattery = (
  batteryMode,
  OutputLoadNotPercent,
  solarPower
) => {
  if (batteryMode === "On Battery") {
    if (solarPower > OutputLoadNotPercent) {
      return "On Solar";
    } else if (OutputLoadNotPercent > solarPower && solarPower > 0) {
      return "On Solar & Battery";
    } else return batteryMode;
  } else return batteryMode;
};
const construct = (devices, timeRN) => {
  try {
    let arr = [];

    devices &&
      devices
        .filter(x => {
          // let inverterFlag =
          //   x.payload &&
          //   x.payload.InverterDetected &&
          //   x.payload.InverterDetected == "NO"
          //     ? true
          //     : false;
          return (
            x.payload &&
            // !inverterFlag &&
            x.DeviceID != null &&
            x.request != null
          );
        })
        .map(device => {
          try {
            let d = {};
            let MiscData = {};
            // let Alarms = {};
            const did = device.owner[0] ? device.owner[0]["CID"] : "None";
            const name = device.owner[0]
              ? device.owner[0]["name"]
              : "Arnergy Solar";
            const InverterData = device.payload.InverterData || [];
            const streetRoute = device.owner[0]
              ? device.owner[0]["streetRoute"]
              : "None";
            // console.log('=========', device.payload.Version)
            // Transformation Begins
            d.version = device.payload.Version || "v2";
            d.paymentModel =
              device.request.length > 0 ? device.request[0].paymentmodel : "--";

            d.sector =
              typeof device.owner[0] === "undefined"
                ? "--"
                : device.owner[0]["sector"] === null
                ? "--"
                : device.owner[0]["sector"];

            if (typeof device.payload["WarningsData"] !== "undefined") {
              // console.log({
              //   id: device.DeviceID,
              //   type: device.payload["WarningsData"].length ? "array" : "object",
              //   data: Object.values(device.payload["WarningsData"])
              // });
              d.Alarms = transformListData(device.payload["WarningsData"])[0];
              let { count, flags } = errorCalc(d.Alarms);
              d.flags = flags;
              if (count < 1) {
                delete d.Alarms;
              }
            }

            d.MiscData =
              typeof device.payload["MiscData"] === "undefined"
                ? (MiscData.FV = "")
                : device.payload["MiscData"];
            d.FV =
              typeof device.payload["MiscData"] === "undefined"
                ? "-"
                : typeof device.payload["MiscData"]["FV"] === "undefined"
                ? "-"
                : device.payload["MiscData"]["FV"] || "-";
            d.InverterId =
              d.version == "v4" || d.version == "v3"
                ? device.DeviceID
                : device.DeviceID;
            d.TimeStamp = device.payload.Timestamp || device.payload.TimeStamp;
            d.id = device.DeviceID;
            d.panelpower =
              d.version == "v4"
                ? panelPowerReduce(device.payload.PowerData, "v4")
                : d.version == "v3" || d.version == "v5" || d.version == "v6"
                ? panelPowerReduce(InverterData)
                : panelPower(device.payload.PVChargingPower);
            let tempBattery =
              device.payload.BatteryData && device.payload.BatteryData.SOC
                ? device.payload.BatteryData.SOC.replace("%", "")
                : device.payload.BatteryCapacity;
            d.BatteryCapacity = roundDown(tempBattery || 0);
            d.deviceType = device.owner[0]
              ? device.owner[0]["deviceType"]["name"]
              : "Arnergy5000";
            d.installedCapacity = installedCapacity(device);
            // console.log({ capacity: device.payload.MiscData.InstallSize });
            // panelPowerReduceRaw
            // device.owner[0]
            //   ? device.owner[0]["deviceType"]["name"]
            //   : "Arnergy 5000";
            d.ownerName = name;
            d.ownerId = did;
            d.address = streetRoute;
            d.batteryMode = batteryMode(device.mode || "", d.version);

            d.expiry =
              moment(device.expiry).format("MMMM Do YYYY, h:mm:ss a") ==
              "Invalid date"
                ? device.expiry
                : moment(device.expiry).format("MMMM Do YYYY, h:mm:ss a");
            d.lastseen =
              d.version == "v4" || d.version == "v3"
                ? timeAgo(device.payload.Timestamp, timeRN)
                : timeAgo(device.payload.TimeStamp, timeRN);

            let timestamp =
              device.payload.Timestamp || device.payload.TimeStamp;

            if (
              Number(timestamp.split(":")[timestamp.split(":").length - 1]) > 59
            ) {
              timestamp = timestamp.slice(0, timestamp.length - 2) + "59";
              console.log(timestamp, "real");
            }

            d.Time = timestamp
              ? `${format(new Date(timestamp), "yyyy-MM-dd'T'HH:mm:ss")}`
              : `Invalid Date`;
            // console.log({expiry: device.payload.Timestamp?device.payload.Timestamp:device.payload.TimeStamp, deviceId: device.DeviceID});
            // roundDown
            let tempLoad =
              d.version == "v4"
                ? roundUp(
                    device.payload.PowerData
                      ? device.payload.PowerData.reduce((acc, obj) => {
                          return (acc += Number(obj["OL%"] || 0));
                        }, 0) / device.payload.PowerData.length
                      : ""
                  )
                : d.version == "v3"
                ? roundUp(
                    InverterData.reduce((acc, obj) => {
                      return (acc += Number(obj["OL%"] || 0));
                    }, 0) / InverterData.length
                  )
                : d.version == "v5" || d.version == "v6"
                ? (device.payload.InvAggrData &&
                    device.payload.InvAggrData["AOL%"]) ||
                  0
                : device.payload.OutputLoadPercent * 1;
            d.OutputLoadPercent = roundDown(tempLoad || 0) + "";

            let tempPanelPower =
              d.version == "v4"
                ? panelPowerReduceRaw(device.payload.PowerData, "v4")
                : d.version == "v3"
                ? panelPowerReduceRaw(InverterData)
                : panelPowerRaw(device.payload.PVChargingPower);

            let tempLoadSum =
              d.version == "v4"
                ? roundUp(
                    device.payload.PowerData
                      ? device.payload.PowerData.reduce((acc, obj) => {
                          return (acc += Number(obj["OL%"] || 0));
                        }, 0)
                      : ""
                  )
                : d.version == "v3"
                ? roundUp(
                    InverterData.reduce((acc, obj) => {
                      return (acc += Number(obj["ACOAP"]));
                    }, 0)
                  )
                : device.payload.OutputLoadPercent * 1;

            d.batteryMode = getExtraSourceWhileOnBattery(
              d.batteryMode,
              tempLoadSum,
              tempPanelPower
            );
            d.contractualLoad = `${
              device.payload.CLoad ? device.payload.CLoad / 1000 : 0
            }kW`;
            d.installedPV = `${
              device.payload.InstPV ? device.payload.InstPV / 1000 : 0
            }kW`;

            // if ( d.version == "v5") {
            //   console.log({bm:d.batteryMode});
            // }

            arr.push(d);
          } catch (error) {
            console.log("map =>", error);
          }
        });
    return arr;
  } catch (error) {
    console.error(error);
  }
};

const saveOsCustomer = ({ commit }, customer) => {
  commit("saveOsCustomer", customer);
};

const saveCustomerProductOptions = ({ commit }, options) => {
  commit("saveCustomerProductOptions", options);
};

// const saveCustomerProductOptions = ({ commit }, options) => {
//   commit("saveCustomerProductOptions", options);
// };

const saveUserNotifications = async ({ commit }, data) => {
  commit("saveUserNotifications", data);
};

export default {
  fillDeviceList,
  refreshList,
  login,
  logout,
  loginNetwork,
  setUserSession,
  setAccess,
  setHome,
  setDrawerMode,
  setRole,
  setTheme,
  toggleSidebar,
  performanceGraphCall,
  performanceGraphCall2,
  handleFilters,
  clearFilters,
  setGlobalTableOptions,
  setPerformanceFilter,
  setCriticalSystems,
  saveOsCustomer,
  saveUserNotifications,
  saveCustomerProductOptions
};



// WEBPACK FOOTER //
// ./src/store/actions.js